import { cloneDeep } from 'lodash';

const newCall = (state, payload) => {
  const newState = cloneDeep(state);
  const { placeId, pointId, userId, userDevice = 'mobile', details, createdAt } = payload;
  if (!newState.calls[pointId]) {
    newState.calls[pointId] = [];
  }
  newState.calls[pointId].push({ placeId, pointId, userId, userDevice, details, createdAt, type: 'call' });
  return newState;
};

export { newCall };
